import { CompleteCondition } from 'modules/queryBuilder/types';
import { CatalogData, MatchesCatalogComparator } from '../types';

const isCatalogCondition = (condition: CompleteCondition): boolean =>
  'catalogField' in condition && 'catalogQuery' in condition;

export const useConvertCatalogCondition = () => {
  return (condition: CompleteCondition): CompleteCondition => {
    /**
     * Typing a custom condition (like a condition with catalog data) to CompleteCondition doesn't register well with typescript.
     * Not ideal but for now ignoring the types and casting to CompleteCondition.
     * This should is similar to casting as "unknown as CompleteCondition"
     * */
    if (isCatalogCondition(condition)) {
      // @ts-ignore
      const { catalogField, catalogQuery, ...restOfCondition } = condition;
      const value = {
        catalogField,
        catalogQuery,
      } as CatalogData;
      // @ts-ignore
      return {
        ...restOfCondition,
        comparatorType: MatchesCatalogComparator.MATCHES_CATALOG_DATA,
        value,
      } as CompleteCondition;
    }
    return condition;
  };
};
